import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';
import guid from '@/shared/utils/guid';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { isDutchTenantConfiguration } from '@/shared/TenantConfigurationConstants';

angular
  .module('cloudX')
  .controller('AmlDocumentDialogCtrl', [
    '$httpParamSerializer',
    'flySvc',
    '$element',
    'close',
    'relation',
    'appUrls',
    '$http',
    '$timeout',
    '$filter',
    'translateListFilter',
    'dataCache',
    AmlDocumentDialogCtrl,
  ]);

function AmlDocumentDialogCtrl(
  $httpParamSerializer,
  flySvc,
  $element,
  close,
  relation,
  appUrls,
  $http,
  $timeout,
  $filter,
  translateListFilter,
  dataCache,
) {
  var vm = this;
  vm.data = {
    relationId: relation.id,
    identificationTemplateId: null,
    beneficiaryTemplateId: null,
    derivedClientResearchTemplateId: null,
    riskTemplateId: null,
    companyTrusteesTemplateId: null,
    personTrusteesTemplateId: null,
    originOfFundsTemplateId: null,
    tags: {},
    selectedTrustees: null,
    addQrCode: false,
  };
  vm.isNlTenant = isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'));
  vm.hasCustomTags = false;
  vm.amlStatus = null;
  vm.loadingPreview = false;
  vm.saving = false;
  vm.preview = null;
  vm.identificationTemplates = null;
  vm.beneficiaryTemplates = null;
  vm.riskTemplates = null;
  vm.companyTrusteesTemplates = null;
  vm.personTrusteesTemplates = null;
  vm.derivedClientResearchTemplates = null;
  vm.originOfFundsTemplates = null;
  vm.templateTags = [];
  vm.hasQrCodeTag = false;

  /* For trustee checkboxes */
  vm.companyTrustees = [];
  vm.companyTrusteesSelected = false;
  vm.personTrustees = [];
  vm.personTrusteesSelected = false;

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };
  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      //Parsing error?
      flySvc.error();
    }
  };
  vm.getStatus = function() {
    $http
      .get(appUrls.api + '/api/relation/AntiMoneyLaunderingInfo/' + relation.id)
      .then(function({ data }) {
        vm.amlStatus = data;
        if (data.trustees) {
          vm.companyTrustees = data.trustees
            .filter(x => x.type === 0)
            .map(x => ({ id: x.id, label: $filter('relationName')(x), selected: true }))
            .sort(dynamicSort('label'));
          vm.personTrustees = data.trustees
            .filter(x => x.type !== 0)
            .map(x => ({ id: x.id, label: $filter('relationName')(x), selected: true }))
            .sort(dynamicSort('label'));
        }
      });
  };
  vm.getStatus();

  vm.generateDocuments = function(dl) {
    if (vm.saving) return;
    vm.saving = true;
    const model = vm.getGenerateModel();
    $http.post(`${appUrls.api}/Api/Relation/AntiMoneyLaunderingDocuments/`, model).then(
      ({ data }) => {
        vm.saving = false;
        if (data) {
          close(data, 500);
          $element.modal('hide');
        }
      },
      error => {
        vm.saving = false;
        showError(error);
      },
    );
  };

  vm.generatePreview = function() {
    vm.loadingPreview = true;
    vm.preview = null;
    const model = vm.getGenerateModel();
    $http
      .post(`${appUrls.api}/Api/Relation/AntiMoneyLaunderingPreview/`, model, {
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          vm.loadingPreview = false;
          if (!response || !response.data) return;
          var blob = new Blob([response.data], { type: 'image/png' });
          var reader = new FileReader();
          reader.onload = function(evt) {
            $timeout(function() {
              vm.preview = evt.target.result;
            }, 0);
          };
          reader.readAsDataURL(blob);
        },
        error => {
          vm.loadingPreview = false;
          showArrayBufferError(error);
        },
      );
  };

  vm.getGenerateModel = function() {
    const model = angular.copy(vm.data);

    model.tags = (vm.templateTags || []).reduce((o, e) => {
      if (!!e.value) {
        o[e.tag] = e.value;
      }
      return o;
    }, {});

    model.selectedTrustees = [
      ...(vm.data.companyTrusteesTemplateId
        ? vm.companyTrustees.filter(x => x.selected).map(x => x.id)
        : []),
      ...(vm.data.personTrusteesTemplateId
        ? vm.personTrustees.filter(x => x.selected).map(x => x.id)
        : []),
    ];

    if (vm.hasQrCodeTag) model.addQrCode = false;

    return model;
  };

  vm.retrieveTags = function() {
    vm.hasQrCodeTag = false;
    const model = vm.getGenerateModel();
    delete model.tags;

    $http.post(`${appUrls.api}/Api/Relation/AntiMoneyLaunderingCustomTags/`, model).then(
      ({ data }) => {
        if (data) {
          vm.templateTags = data.reduce((result, tag) => {
            //Lower case and remove {}
            const key = tag.toLowerCase().replace(/[{}]/, '');
            if (key === 'document.qr') {
              vm.hasQrCodeTag = true;
              return result; //Ignore qr code tag
            }
            const oldTag = vm.templateTags.find(x => x.key === key);

            result.push({
              tag,
              key,
              info: translateListFilter(`{${key}}`, 'mailplaceholder', ''),
              value: (oldTag && oldTag.value) || '', //Copy old value into new object
            });
            return result;
          }, []);
        } else {
          vm.templateTags = [];
        }
      },
      error => {
        showError(error);
      },
    );
  };

  var getBestMatchingTemplateId = function(templates) {
    if (!templates || !templates.length) return guid.empty;
    var filtered = templates.filter(x => x.languageCode === relation.languageCode);
    if (filtered.length === 1) return filtered[0];
  };

  vm.canGenerate = function() {
    //At least one document should be selected
    if (vm.data.identificationTemplateId) return true;
    if (vm.data.riskTemplateId) return true;
    if (vm.data.beneficiaryTemplateId) return true;
    if (vm.data.derivedClientResearchTemplateId && vm.isNlTenant) return true;
    if (vm.data.originOfFundsTemplateId && vm.isNlTenant) return true;

    //For the trustees, the template needs to be selected and there should be at least one trustee selected
    if (
      vm.data.companyTrusteesTemplateId &&
      vm.companyTrustees &&
      vm.companyTrustees.some(x => x.selected)
    )
      return true;
    if (
      vm.data.personTrusteesTemplateId &&
      vm.personTrustees &&
      vm.personTrustees.some(x => x.selected)
    )
      return true;

    // No documents will be generated
    return false;
  };

  vm.loadTemplates = function() {
    $http
      .get(`${appUrls.api}/Api/DocumentTemplate/Templates/`, {
        params: {
          templateTypes: [4, 5, 6, 7, 8, 9, 24, 29],
          companyId: relation.companyId,
        },
      })
      .then(
        ({ data }) => {
          const relationType = relation.type;
          const templates = data
            .filter(x => x.relationType === null || x.relationType === relationType)
            .map(x => ({ ...x, label: `${x.name} (${x.languageCode})` }));
          const systemTemplate = {
            id: guid.empty,
            label: $filter('translate')('Use system template'),
          };

          vm.identificationTemplates = [
            systemTemplate,
            ...templates.filter(x => x.templateType === 4 || x.templateType === 5),
          ];
          vm.beneficiaryTemplates = [
            systemTemplate,
            ...templates.filter(x => x.templateType === 7),
          ];
          vm.companyTrusteesTemplates = [
            systemTemplate,
            ...templates.filter(x => x.templateType === 9),
          ];
          vm.personTrusteesTemplates = [
            systemTemplate,
            ...templates.filter(x => x.templateType === 8),
          ];
          if (vm.isNlTenant) {
            vm.derivedClientResearchTemplates = [
              systemTemplate,
              ...templates.filter(x => x.templateType === 24),
            ];
          } else {
            vm.derivedClientResearchTemplates = [];
          }
          vm.riskTemplates = [systemTemplate, ...templates.filter(x => x.templateType === 6)];
          if (vm.isNlTenant) {
            vm.originOfFundsTemplates = [
              systemTemplate,
              ...templates.filter(x => x.templateType === 29),
            ];
          } else {
            vm.originOfFundsTemplates = [];
          }
          vm.data.identificationTemplateId = (
            vm.identificationTemplates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          vm.data.beneficiaryTemplateId = (
            vm.beneficiaryTemplates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          vm.data.riskTemplateId = (
            vm.riskTemplates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          vm.data.companyTrusteesTemplateId = (
            vm.companyTrusteesTemplates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          vm.data.personTrusteesTemplateId = (
            vm.personTrusteesTemplates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          if (vm.isNlTenant) {
            vm.data.derivedClientResearchTemplateId = (
              vm.derivedClientResearchTemplates.find(
                x => x.languageCode === relation.languageCode,
              ) || {
                id: guid.empty,
              }
            ).id;
          }
          if (vm.isNlTenant) {
            vm.data.originOfFundsTemplateId = (
              vm.originOfFundsTemplates.find(x => x.languageCode === relation.languageCode) || {
                id: guid.empty,
              }
            ).id;
          }
          vm.retrieveTags();
        },
        error => {
          showError(error);
        },
      );
  };

  vm.loadTemplates();

  vm.cancel = function() {
    close(null, 500);
  };
}
